class HelloModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerdown", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("pointerdown", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    const allModals = document.querySelectorAll("hello-modal-dialog");

    allModals.forEach((modal) => {
      if (modal !== this) {
        modal.hide();
      }
    });
    if (this.id === "PopupModal-installment_info") {
      document.querySelectorAll('.installments-item-container, .installments-info').forEach(item => {
        item.classList.remove('active');
      });
      const allTabs = document.querySelectorAll(".payment_subtitle");
      allTabs.forEach(tab => tab.classList.remove("active"));
      allTabs[0].classList.add("active");
      allTabs[0].scrollIntoView({ behavior: "smooth", inline: "center" }); 

      document.querySelectorAll('.installments-row').forEach(item => { item.style.display = 'none'; });
      const installmentRow = document.querySelector('.installments-row.installment');
      installmentRow ? installmentRow.style.display = 'block' : installmentRow.style.display = 'none'
    }
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    const event = new CustomEvent("modalOpened", {
      detail: { modalId: this.id },
      bubbles: true 
    });
    this.dispatchEvent(event);
  }

  hide() {
    document.body.dispatchEvent(new CustomEvent("modalClosed", {
      detail: { modalId: this.id },
      bubbles: true 
    }));
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("hello-modal-dialog", HelloModalDialog);

class HelloModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("hello-modal-opener", HelloModalOpener);
